import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const OuterRing = styled.div`
  margin-top: 160px;
  text-align: center;
`;

export const AccessLine = styled.p`
  text-align: center;
  max-width: 275px;
  margin: 20px auto;
`;
export const Description = styled.p`
  text-align: center;
  max-width: 320px;
  margin: 0 auto;
`;
export const QueryLine = styled.p`
  text-align: center;
  margin: 0 auto;
  max-width: 325px;
`;
export const UnderLine = styled.span`
  text-decoration: underline;
  color: ${({ theme }) => theme.colors.azure};
`;

export const LastLine = styled.p`
  margin-top: 20px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: ${({ theme }) => theme.spacing.xl};
`;

export const ButtonWrapper = styled.div`
  width: 90%;
`;

export const SupportLink = styled(Link)`
  color: ${({ theme }) => theme.colors.oxfordBlue};
`;
